<template>
  <div>
    <b-row class="pt-2 pb-1">
      <b-col cols="12" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
    </b-row>

    <b-row class="mx-0">
      <b-col md="3" sm="6" cols="12" class="mb-1">
        <b-card class="m-0 text-center" no-body>
          <b-card-body>
            <feather-icon icon="VideoIcon" size="24" class="mb-1 text-primary" />
            <h2 class="mb-0">{{ data ? data.devices.total : "-" }}</h2>
            <small class="text-muted text-capitalize">{{ $t("axis_body_cam.overview.devices") }}</small>
            <div class="text-muted small">{{ $t("axis_body_cam.overview.active") }}: {{ data ? data.devices.active : "-" }}</div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col md="3" sm="6" cols="12" class="mb-1">
        <b-card class="m-0 text-center" no-body>
          <b-card-body>
            <feather-icon icon="UsersIcon" size="24" class="mb-1 text-info" />
            <h2 class="mb-0">{{ data ? data.users.total : "-" }}</h2>
            <small class="text-muted text-capitalize">{{ $t("axis_body_cam.overview.users") }}</small>
            <div class="text-muted small">{{ $t("axis_body_cam.overview.active") }}: {{ data ? data.users.active : "-" }}</div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col md="3" sm="6" cols="12" class="mb-1">
        <b-card class="m-0 text-center" no-body>
          <b-card-body>
            <feather-icon icon="FilmIcon" size="24" class="mb-1 text-warning" />
            <h2 class="mb-0">{{ data ? data.recordings.total : "-" }}</h2>
            <small class="text-muted text-capitalize">{{ $t("axis_body_cam.overview.recordings") }}</small>
            <div class="text-muted small">{{ $t("axis_body_cam.overview.today") }}: {{ data ? data.recordings.today : "-" }}</div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col md="3" sm="6" cols="12" class="mb-1">
        <b-card class="m-0 text-center" no-body>
          <b-card-body>
            <feather-icon icon="HardDriveIcon" size="24" class="mb-1 text-success" />
            <p class="mb-1 text-muted small">{{ $t("axis_body_cam.overview.configure_dock_hint") }}</p>
            <b-button variant="primary" size="sm" :disabled="downloadingConnectionFile" @click="downloadConnectionFile">
              <feather-icon icon="DownloadIcon" size="14" class="mr-25" />
              {{ $t("axis_body_cam.overview.configure_dock") }}
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card-group deck class="mx-2">
      <b-card class="m-0" no-body>
        <b-card-header>
          <h4 class="mb-0 text-capitalize">{{ $t("axis_body_cam.overview.recent_recordings") }}</h4>
        </b-card-header>
        <b-table
          :items="data ? data.recent_recordings : []"
          :fields="tableColumns"
          responsive
          show-empty
          :empty-text="$t('no_record_found')"
        >
          <template #head()="row">
            <span>{{ $t(row.label) }}</span>
          </template>
        </b-table>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardHeader, BTable, BButton } from "bootstrap-vue";
import { ref, onMounted } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import axios from "@/libs/axios";
import moment from "moment-timezone";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardHeader,
    BTable,
    BButton,
    BreadcrumbMenu,
  },
  setup() {
    const data = ref(null);
    const toast = useToast();
    const downloadingConnectionFile = ref(false);

    const tableColumns = [
      { label: "axis_body_cam.recordings.container_name", key: "container_name" },
      { label: "axis_body_cam.recordings.user", key: "user" },
      { label: "axis_body_cam.recordings.device", key: "device" },
      { label: "axis_body_cam.recordings.start_time", key: "start_time", formatter: (value) => (value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "-") },
      { label: "axis_body_cam.recordings.status", key: "status" },
    ];

    const formatBytes = (bytes) => {
      if (!bytes) return "0 B";
      const units = ["B", "KB", "MB", "GB", "TB"];
      let value = bytes;
      let unitIndex = 0;
      while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex++;
      }
      return `${value.toFixed(1)} ${units[unitIndex]}`;
    };

    const downloadConnectionFile = async () => {
      downloadingConnectionFile.value = true;
      try {
        const response = await axios.get("v1/body-worn/connection-file", { responseType: "blob" });
        const url = window.URL.createObjectURL(response.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = "sbo-content-destination.json";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (e) {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error generando el archivo de conexión",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        downloadingConnectionFile.value = false;
      }
    };

    onMounted(async () => {
      data.value = await store.dispatch("axis_body_cam_overview/get");
    });

    return {
      data,
      tableColumns,
      formatBytes,
      downloadingConnectionFile,
      downloadConnectionFile,
    };
  },
};
</script>
